import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Box } from "@mui/material";
import SoftButton from "components/SoftButton";
import PropTypes from 'prop-types';
import { useState, useContext } from 'react';
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";

import swal from 'sweetalert2';
import AuthContext from "context/AuthContext";
import refreshAccessToken from 'adminRefresToken';
import { api } from "utils/Api";
import { showSuccess } from "utils/messageAlerts";

function EditFormPopup({ user, onClose }) {
  const [first_name, setFirstName] = useState(user.first_name);
  const [last_name, setLastName] = useState(user.last_name);
  const [email, setEmail] = useState(user.email);
  const [cellPhone, setCellPhone] = useState(user.phone_number);
  const [userName, setUserName] = useState(user.username);
  // const [address, setAddress] = useState(user.address);
  // const [streetAddress, setStreetAddress] = useState(user.street_address);
  // const [city, setCity] = useState(user.city);
  // const [state, setState] = useState(user.state);
  // const [zipCode, setZipCode] = useState(user.zip_code);
  // const [emergencyPhone, setEmergencyPhone] = useState(user.emergency_contact);
  // const [selectedImage, setSelectedImage] = useState(null);

  const { adminauthTokens, staffauthTokens, authTokens, managerauthTokens, logoutUser } = useContext(AuthContext);
  const selectedAuthToken = managerauthTokens || authTokens || staffauthTokens;


  const [loading, setLoading] = useState(false); // Add loading state


  const handleSubmit = async (event) => {
    event.preventDefault();

    // // Check if a new profile image is selected and append it to the FormData
    // if (selectedImage) {
    //   formData.append('image', selectedImage);
    // }

    const payload = {
      first_name,
      last_name,
      email,
      phone_number: cellPhone,
      username: userName,
    }

    try {
      setLoading(true);
      await api.user.updateUserDetails(user.id, payload);

      // Profile update was successful
      showSuccess('Your profile information has been updated successfully.');
      onClose(); // Close the edit form
    } catch (error) {
    }
    finally {
      setLoading(false);
    }
  };


  return (
    <Dialog open={true} onClose={onClose}>
      <DialogTitle>Edit Profile Information</DialogTitle>
      <DialogContent>
        <form onSubmit={handleSubmit}>
          <Box sx={{ display: 'flex', flexDirection: 'column', maxWidth: '100%', width: '500px' }}>

            <SoftBox mb={2}>
              <SoftBox mb={1} ml={0.5}>
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  User Name <Box component="span" color="error.main">*</Box>
                </SoftTypography>
              </SoftBox>
              <SoftInput
                type="text"
                name="username"
                placeholder="Username"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                required
              />
            </SoftBox>

            <SoftBox mb={2}>
              <SoftBox mb={1} ml={0.5}>
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  First Name <Box component="span" color="error.main">*</Box>
                </SoftTypography>
              </SoftBox>
              <SoftInput
                type="text"
                name="first_name"
                placeholder="First Name"
                value={first_name}
                onChange={(e) => setFirstName(e.target.value)}
                required
              />
            </SoftBox>
            <SoftBox mb={2}>
              <SoftBox mb={1} ml={0.5}>
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Last Name <Box component="span" color="error.main">*</Box>
                </SoftTypography>
              </SoftBox>
              <SoftInput
                type="text"
                name="last_name"
                placeholder="Last Name"
                value={last_name}
                onChange={(e) => setLastName(e.target.value)}
                required
              />
            </SoftBox>
            <SoftBox mb={2}>
              <SoftBox mb={1} ml={0.5}>
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Email <Box component="span" color="error.main">*</Box>
                </SoftTypography>
              </SoftBox>
              <SoftInput
                type="email"
                name="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </SoftBox>
            {/* <SoftBox mb={2}>
              <SoftBox mb={1} ml={0.5}>
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Home Phone
                </SoftTypography>
              </SoftBox>
              <SoftInput
                type="text"
                name="home_phone"
                placeholder="Home Phone"
                value={homePhone}
                onChange={(e) => setHomePhone(e.target.value)}
              />
            </SoftBox> */}
            <SoftBox mb={2}>
              <SoftBox mb={1} ml={0.5}>
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Cell Phone <Box component="span" color="error.main">*</Box>
                </SoftTypography>
              </SoftBox>
              <SoftInput
                type="text"
                name="cell_phone"
                placeholder="Cell Phone"
                value={cellPhone}
                onChange={(e) => setCellPhone(e.target.value)}
                required
              />
            </SoftBox>
            {/* <SoftBox mb={2}>
              <SoftTypography
                variant="button"
                fontWeight="bold"
                textGradient
              >
                Profile picture &nbsp;
              </SoftTypography>
              <SoftTypography
                variant="button"
                fontWeight="regular"
              >
                &nbsp;&nbsp; Supported files JPG, JPEG, PNG of up to 4MB &nbsp;
              </SoftTypography>
              <SoftInput type="file" accept="image/*" name="image" onChange={(e) => setSelectedImage(e.target.files[0])} />
            </SoftBox> */}
            {/* <SoftBox mb={2}>
              <SoftBox mb={1} ml={0.5}>
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Address
                </SoftTypography>
              </SoftBox>
              <SoftInput
                type="text"
                name="address"
                placeholder="Address"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
            </SoftBox>
            <SoftBox mb={2}>
              <SoftBox mb={1} ml={0.5}>
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Street Address
                </SoftTypography>
              </SoftBox>
              <SoftInput
                type="text"
                name="street_address"
                placeholder="Street Address"
                value={streetAddress}
                onChange={(e) => setStreetAddress(e.target.value)}
              />
            </SoftBox>
            <SoftBox mb={2}>
              <SoftBox mb={1} ml={0.5}>
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  City
                </SoftTypography>
              </SoftBox>
              <SoftInput
                type="text"
                name="city"
                placeholder="City"
                value={city}
                onChange={(e) => setCity(e.target.value)}
              />
            </SoftBox>
            <SoftBox mb={2}>
              <SoftBox mb={1} ml={0.5}>
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  State
                </SoftTypography>
              </SoftBox>
              <SoftInput
                type="text"
                name="state"
                placeholder="State"
                value={state}
                onChange={(e) => setState(e.target.value)}
              />
            </SoftBox>
            <SoftBox mb={2}>
              <SoftBox mb={1} ml={0.5}>
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Zip Code
                </SoftTypography>
              </SoftBox>
              <SoftInput
                type="number"
                name="zip_code"
                placeholder="Zip Code"
                value={zipCode}
                onChange={(e) => setZipCode(e.target.value)}
              />
            </SoftBox>
            <SoftBox mb={2}>
              <SoftBox mb={1} ml={0.5}>
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Emergency Phone
                </SoftTypography>
              </SoftBox>
              <SoftInput
                type="text"
                name="emergency_phone"
                placeholder="Emergency Phone"
                value={emergencyPhone}
                onChange={(e) => setEmergencyPhone(e.target.value)}
              />
            </SoftBox> */}

          </Box>
        </form>
      </DialogContent>
      <DialogActions>
        <SoftButton onClick={onClose}>Cancel</SoftButton>
        <SoftButton onClick={handleSubmit} variant="gradient" color="dark" type="submit" disabled={loading}>
          {loading ? "Updating..." : "Update"}
        </SoftButton>
      </DialogActions>
    </Dialog>
  );
}

EditFormPopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  user: PropTypes.func.isRequired,
};

export default EditFormPopup;
